import axios from 'axios';
import { baseUrl } from '../hooks/useEndpoints';
import {
  IAFITeamResponse,
  IAFIAthleteDetail,
  IAFIComponentDetail,
  IAFINotificationsResponse,
} from '../models/afi';

export const antifragilityEndpoints = {
  getTeamAFI: (teamId: string, params?: { date?: string; period?: number }) =>
    axios.get<IAFITeamResponse>(`${baseUrl}/afi/team/${teamId}`, { params }),

  getAthleteAFI: (athleteId: string, params: { teamId: string; days?: number }) =>
    axios.get<IAFIAthleteDetail>(`${baseUrl}/afi/athlete/${athleteId}`, { params }),

  getAFIComponent: (
    athleteId: string,
    component: 'A' | 'B' | 'C',
    params: { teamId: string; weeks?: number }
  ) =>
    axios.get<IAFIComponentDetail>(
      `${baseUrl}/afi/athlete/${athleteId}/component/${component}`,
      { params }
    ),

  getAFINotifications: (params: { teamId: string; unreadOnly?: boolean; athleteId?: string }) =>
    axios.get<IAFINotificationsResponse>(`${baseUrl}/afi/notifications`, { params }),

  markAFINotificationsRead: (body: { notificationIds: string[] }) =>
    axios.post(`${baseUrl}/afi/notifications/read`, body),
};
